import { render, staticRenderFns } from "./vigilante_parque.vue?vue&type=template&id=36c30961&scoped=true"
import script from "./vigilante_parque.vue?vue&type=script&lang=js"
export * from "./vigilante_parque.vue?vue&type=script&lang=js"
import style0 from "./vigilante_parque.vue?vue&type=style&index=0&id=36c30961&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c30961",
  null
  
)

export default component.exports